module.exports = "/assets/data/f7973fe4b952e7c19c414650653f8070-SN3.data.json";